import { add, checkAdd } from "./add"
import { show, updateIcon } from "./show"
import hermes from "hermes"

// import { stickyBottomCart } from "./sticky"

export const cartInit = () => {
  require("basket-element")
  add()

  hermes.on("updateBasket", data => {
    updateIcon(data)
  })
  // checkAdd()
  // show()
  // stickyBottomCart()
}
